<template>
    <div>
        <div class="container">
            <div :key="accessoryType.id" v-for="accessoryType in accessoriesTypes" class="overview__item">
                <h3 class="overview__title">{{ accessoryType.title }}</h3>
                <accessory-option-list :options="accessoryType.options" :accessory-type="accessoryType"/>
                <div class="overview__controls z1 m--t-1">
                    <custom-button @click="update(accessoryType.id)" iconic v-if="false === accessoryType.systemic">
                        <span icon edit></span>Upravit
                    </custom-button>
                    <custom-button @click="remove(accessoryType)" iconic class="visible-on-overview-hover"
                                   v-if="false === accessoryType.systemic">
                        <span icon remove></span>Odstranit
                    </custom-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import UpdateAccessoryTypeDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/UpdateAccessoryTypeDialog';
import AccessoryOptionList
    from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/Option/AccessoryOptionList';

export default {
    name:       'AccessoryTypeList',
    components: {AccessoryOptionList, CustomButton},
    computed:   {
        accessoriesTypes() {
            return this.$store.getters['projects/project/accessory/accessoriesOwnOrFilled'];
        }
    },
    methods:    {
        update(accessoryTypeId) {
            this.$modal.show(UpdateAccessoryTypeDialog, {accessoryTypeId}, defaultModalParameters());
        },
        remove(accessoryType) {
            const {id, title} = accessoryType;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete příslušenství <strong>' + title + '</strong> odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/accessory/removeAccessoryType', id)
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        },
    }
}
</script>
